<template>
    <div class="row">
        <template v-if="dropdown">
            <div class="col-xs-12 col-lg-5">
                <single-select
                    :options="inactiveDatasets"
                    v-model="singleSelectValue"
                    @input="onLabelAdd"
                    :getOptionLabel="getLabelText"
                    :placeholder="dropdown.placeholder"
                    :disabled="dropdownDisabled"
                />
            </div>
            <div class="col-xs-12 col-lg-7">
                <ul class="legend">
                    <li class="legend__item--label"
                        :class="{'is-deactived': dataset.hidden}"
                        v-for="dataset in activeDatasets"
                        @click="onLabelToggle(dataset)">

                        <span>
                            <span class="legend__item__dot" :style="'background:' + dataset.borderColor"></span>
                            {{dataset.label}}
                        </span>

                        <span class="legend__item--label__close" @click.prevent="onLabelRemove(dataset)">
                            <i class="mdi mdi-close"></i>
                        </span>
                    </li>
                </ul>
            </div>
        </template>

        <div v-else class="col-xs-12">
            <ul class="legend">
                <li class="legend__item--label"
                    :class="{'is-deactived': dataset.hidden}"
                    v-for="dataset in activeDatasets"
                    @click="onLabelToggle(dataset)">

                    <span>
                        <span class="legend__item__dot" :style="'background:' + dataset.borderColor"></span>
                        {{dataset.label}}
                    </span>
                </li>
            </ul>
        </div>

        <div v-if="dropdownDisabled" class="col-xs-12">
            <div class="dropdown__disabled_warning"><i
                class="dropdown__disabled_warning__icon mdi mdi-alert-circle-outline"></i> {{dropdown.limit_warning}}
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop, Watch} from 'vue-property-decorator';
    import SingleSelect from '../general/SingleSelect';
    import _ from 'lodash';

    @Component({
        components: {
            SingleSelect,
        }
    })
    export default class GraphLegend extends Vue {
        @Prop({type: Array, default: () => ([])})
        datasets;
        @Prop({type: Object, default: null})
        dropdown;
        @Prop({type: Array, default: () => ([])})
        value;
        @Prop({type: String, default: ''})
        dropdownPlaceholder;

        singleSelectValue = null;

        get activeDatasets() {
            return this.value;
        }

        set activeDatasets(value) {
            this.$emit('input', value);
        }

        get inactiveDatasets() {
            return _.difference(this.datasets, this.activeDatasets);
        }

        get dropdownDisabled() {
            if (!this.dropdown) {
                return false;
            }
            return this.activeDatasets.length >= this.dropdown.limit;
        }

        @Watch('datasets')
        @Watch('dropdown')
        onDatasetsChanged() {
            const active = (this.activeDatasets || []);
            active.splice(0, active.length);
            if (!this.dropdown) {
                (this.datasets || []).forEach(dataset => this.onLabelAdd(dataset));
            } else {
                (this.datasets || []).forEach(dataset => dataset.enabled ? this.onLabelAdd(dataset) : this.onLabelRemove(dataset));
            }
        }

        mounted() {
            this.onDatasetsChanged();
        }

        getLabelText(dataset) {
            return dataset.label;
        }

        onLabelAdd(dataset) {
            this.$nextTick(() => {
                // Clear the selected value from the input box
                this.singleSelectValue = null;
            });
            if (this.activeDatasets.indexOf(dataset) !== -1) {
                return;
            }
            if (this.dropdownDisabled) {
                return;
            }
            this.activeDatasets.push(dataset);
            if (this.dropdown) {
                dataset.hidden = false;
            }
            this.$emit('add', dataset);
        }

        onLabelRemove(dataset) {
            const index = this.activeDatasets.indexOf(dataset);
            if (index !== -1) {
                this.activeDatasets.splice(index, 1);
            }
            if (this.dropdown) {
                dataset.hidden = true;
            }
            this.$emit('remove', dataset);
        }

        onLabelToggle(dataset) {
            this.$emit('toggle', dataset);
            dataset.hidden = !dataset.hidden;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/graphs/GraphLegend.vue